/*
 * File: AppointmentFilterForm.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and populates the patient appointment filters form
 */
import React from "react";
import UIFilterForm from "components/filter-view/UIFilterForm";
import UIProgress from "components/ui/UIProgress";
import FilterForm from "./FilterForm";
import ApptFormOptions from "services/appointments/store/ApptFormOptions";
import FilterStore from "components/filter-view/FilterStore";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

class AppointmentFilterForm extends React.Component {
  state = { loading: true };

  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.filterStore = FilterStore.create({ fields: FilterForm });
  }

  componentDidMount() {
    this.populateFilterStoreFields();
  }

  async populateFilterStoreFields() {
    let statusesFromAPI = await this.context
      .getStore(ApptFormOptions)
      .getStatuses();
    statusesFromAPI[0].name = "All Appointment Statuses";
    this.setFormOptions("statusId", statusesFromAPI);
    this.setState({ loading: false });
  }

  setFormOptions(key, val) {
    let field = this.filterStore.fields.find(m => m.name === key);
    field.setOptions(val);
  }

  onChange = (key, value) => {
    this.props.filterModel.update(key, value);
  };

  content = () => {
    return (
      <UIFilterForm
        fields={this.filterStore.fields}
        data={this.props.filterModel}
        parentOnChange={this.onChange}
      />
    );
  };

  render() {
    let { loading } = this.state;
    return (
      <div>
        {loading && <UIProgress />}
        {!loading && this.content()}
      </div>
    );
  }
}

AppointmentFilterForm.propTypes = {
  filterModel: PropTypes.object.isRequired
};

export default AppointmentFilterForm;
